(function () {
  'use strict';

  /* @ngdoc object
   * @name wbAccount.wbCompany
   * @description
   *
   */
  angular
    .module('wbAccount.wbCompany', [
      'ui.router'
    ]);
}());
